/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    
    interface ILocationSelectorController{
        securityAccess: SecurityAccessEnum;
        ngModel: angular.INgModelController;
        
        disabled: boolean;
        securityDisabled: boolean;
        onSwitchLocation: Function;
        

        init(): void;
    }

    export class LocationSelectorController implements ILocationSelectorController {
        static $inject = [
            '$scope',
            '$q',
            "$window",
            "$mdDialog",
            "meevo.AppSettings",
            "meevo.components.common.IdentityService",
            "meevo.components.common.DataService"
        ];

        context: ILocationSelectorContext;

        securityAccess: SecurityAccessEnum;

        // comes from directive's link function
        ngModel: angular.INgModelController;
        onSwitchLocation: Function;

        disabled: boolean;
        securityDisabled: boolean = false;
        

        constructor(
            private $scope: any,
            private $q: angular.IQService,
            private $window: angular.IWindowService,
            private $mdDialog: angular.material.IDialogService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            private identityService: Meevo.Components.Common.IIdentityService,
            private dataService: Meevo.Components.BaseClasses.IDataService
        ) {
            let fn: Function = null;

            if (_.isFunction(this.onSwitchLocation)) {
                fn = this.onSwitchLocation;
            }

            this.context = new LocationSelectorContext($window, appSettings, identityService, dataService, fn, $scope.excludeCurrentLocation);
        }

        init(): void {
            this.context.ngModel = this.ngModel;
        }
    }
}